import {GLOBALS} from "../config/env";

export const ValidateStore = (storeId) => async () => {
    const {url,apiKey} =  GLOBALS.config.covidService;
    if(storeId && storeId.length === 5){

        try{
            const response = await  get(url + "/stores-validate/" + storeId, apiKey);
            if(response && response.status === 200){
                console.log("ValidateStore success :" + JSON.stringify(response));
                return true;
            }
            else{
                console.log("ValidateStore failed " + JSON.stringify(response))
                return false;
            }
        }
        catch (err){
            console.log("ValidateStore error " + JSON.stringify(err))
            return false;
        }
    }
    else {
        return  false;
    }

}


async function get(url, apiKey) {
    const response = await fetch(url, {
        method: 'GET',
        mode: "cors",
        credentials: "omit",
        headers: {
            'X-Subscription-Key':apiKey
        }
    });
    return response;
}